import React from "react";

/**
 * @deprecated Legacy VUD icon set (`vismaicon-*`). For new code use
 * `Fundamentals/Icon/SpirisIcon` for a decorative icon or
 * `Fundamentals/IconButton/SkynetIconButton` for a clickable one.
 * Glyph names differ between the sets, so look the spiris icon up rather than reusing the name.
 */
export default function SkynetIcon({ icon, title, onClick = undefined, disabled = undefined, filled = false })
{
    return <span className={`vismaicon ${filled ? "vismaicon-filled" : "vismaicon-dynamic"} ${icon}${onClick ? " cursorpointer" : ""} ${disabled ? "disabled" : ""}`} title={title} onClick={onClick} tabIndex={onClick ? "0" : "-1"}></span>
}